import { Controller } from '@hotwired/stimulus'
import { jquery } from 'utils/jquery'

export default class extends Controller {
  static targets = ['languageSelect']

  declare languageSelectTarget: HTMLInputElement;

  initialize(): void {
    this.initializeWithRetry();
  }

  // select2 patches $.fn from a Sprockets bundle loaded independently of
  // jQuery itself, so it can still be missing after jQuery resolves (slow
  // network, blocked/failed script load — same class of event as Rollbar
  // #3267, now #11412). Retry briefly, then fall back to native <select>.
  private initializeWithRetry(attempt: number = 0): void {
    const MAX_RETRIES = 5;
    const RETRY_DELAY_MS = 200;

    const $ = jquery();

    if ($ && typeof $.fn.select2 === 'function') {
      let languageSelect = $(this.languageSelectTarget).select2()

      languageSelect.on('change', () => {
        this.redirectToLocale(languageSelect.val());
      })
      return;
    }

    if (attempt < MAX_RETRIES) {
      window.setTimeout(() => this.initializeWithRetry(attempt + 1), RETRY_DELAY_MS);
      return;
    }

    // select2 fires only jQuery events — without it, fall back to a plain
    // native listener so voters can still switch language (Rollbar #3267).
    this.languageSelectTarget.addEventListener('change', () => {
      this.redirectToLocale(this.languageSelectTarget.value);
    })
  }

  private redirectToLocale(selectedLocale: string): void {
    let url = new URL(window.location.href);

    url.searchParams.set('locale', selectedLocale);
    window.location.href = url.href;
  }
}
